(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/utils/wager-utils.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/utils/wager-utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const wagerHelper = {
  getIsSubscription: wager => wager.isSubscription,
  getDistanceFromWin: (wager, result, withCircle) => {
    const closetsWinningCircle = withCircle ? result === null || result === void 0 ? void 0 : result.distribution.at(-1).distanceMeters : 0;
    const fromLong = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.longitude.replace(',', '.'));
    const fromLat = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.latitude.replace(',', '.'));
    const from = [fromLat, fromLong];
    const toLat = parseFloat(result.location.latitude.replace(',', '.'));
    const toLong = parseFloat(result.location.longitude.replace(',', '.'));
    const to = [toLat, toLong];
    const distanceStr = svs.lyckoplatsen.utils.format.getDistance({
      from,
      to,
      subMeter: closetsWinningCircle
    });
    if (distanceStr.trim() === '1 m') {
      return '<1 m';
    }
    return distanceStr;
  },
  getClosetsWagerToWinDistance: (wagers, result) => {
    const distances = wagers.map(_ref => {
      let {
        wager
      } = _ref;
      const {
        longitude,
        latitude
      } = wager.bets[0].geoBoardData.geoLoc;
      const from = [parseFloat(latitude.replace(',', '.')), parseFloat(longitude.replace(',', '.'))];
      const to = [parseFloat(result.location.latitude.replace(',', '.')), parseFloat(result.location.longitude.replace(',', '.'))];
      const closestWinningCircle = result === null || result === void 0 ? void 0 : result.distribution.at(-1).distanceMeters;
      return svs.lyckoplatsen.utils.format.getDistance({
        from,
        to,
        subMeter: closestWinningCircle,
        format: false
      });
    });
    const closetsWagerToWinDistance = Math.min(...distances);
    return closetsWagerToWinDistance;
  },
  getCompletedDrawTime: (wager, result) => {
    const {
      productId
    } = result;
    const completedDraw = wager.completedDraws.find(draw => {
      const isSameProduct = productMapping.getProduct(draw.productId) === productMapping.getProduct(productId);
      const isSameDraw = draw.drawNumber === result.drawNumber;
      return isSameProduct && isSameDraw;
    });
    return completedDraw.time;
  },
  getWins: (wagers, result) => {
    const wins = wagers === null || wagers === void 0 ? void 0 : wagers.flatMap(wager => wager.wins.filter(win => {
      const isSameProduct = productMapping.isSameProduct(win.productId, result === null || result === void 0 ? void 0 : result.productId);
      const isSameDraw = win.drawNumber === (result === null || result === void 0 ? void 0 : result.drawNumber);
      return isSameProduct && isSameDraw;
    }).map(win => _objectSpread(_objectSpread({}, win), {}, {
      isSubscription: wager.isSubscription
    })));
    return wins || [];
  },
  getIsProlongable: wager => !(wager !== null && wager !== void 0 && wager.isSubscription) && (wager === null || wager === void 0 ? void 0 : wager.totalDrawCount) + (wager === null || wager === void 0 ? void 0 : wager.addonTotalDrawCount) === (wager === null || wager === void 0 ? void 0 : wager.completedDraws.length),
  getWin: (wager, result) => wager.wins.find(win => {
    const isSameProduct = productMapping.isSameProduct(win.productId, result.productId);
    const isSameDraw = win.drawNumber === result.drawNumber;
    return isSameProduct && isSameDraw;
  }),
  getWinPayoutMessage: wins => {
    const hasNormalWin = wins.some(win => !win.isSubscription);
    const hasSubscriptionWin = wins.some(win => win.isSubscription);
    switch (true) {
      case hasNormalWin && hasSubscriptionWin:
        return 'Vinsten har satts in på ditt spelkonto respektive bankkonto, om du angivit ett.';
      case hasSubscriptionWin:
        return 'Vinsten har betalats ut till ditt bankkonto, om du har angivit ett. Annars har den satts in på ditt spelkonto.';
      default:
        return 'Vinsten har satts in på ditt spelkonto.';
    }
  }
};
setGlobal('svs.lyckoplatsen.shared_mybets_wager.utils', {
  wagerHelper
});

 })(window);